// Bianca Fiore — scripts compartidos (vanilla, sin librerías externas)
(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.bf-reveal:not(.bf-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bf-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bf-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('bf-visible'); });
      obs.disconnect();
    }, 1800);
  }

  function initCarruseles() {
    document.querySelectorAll('[data-bf-carrusel]').forEach(function (wrap) {
      var pista = wrap.querySelector('[data-bf-pista]');
      var prev = wrap.querySelector('[data-bf-prev]');
      var next = wrap.querySelector('[data-bf-next]');
      if (!pista || (!prev && !next)) return;
      var paso = function () {
        var tarjeta = pista.querySelector(':scope > *');
        return tarjeta ? tarjeta.getBoundingClientRect().width + 20 : 280;
      };
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-bf-cifra]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var fin = parseFloat(el.getAttribute('data-bf-cifra')) || 0;
        var sufijo = el.getAttribute('data-bf-sufijo') || '';
        var dur = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var prog = Math.min((ts - inicio) / dur, 1);
          var valor = Math.round(fin * (1 - Math.pow(1 - prog, 3)));
          el.textContent = valor + sufijo;
          if (prog < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-bf-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-bf-principal]');
      var minis = galeria.querySelectorAll('[data-bf-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-bf-src');
          var alt = mini.getAttribute('data-bf-alt') || '';
          if (!src) return;
          principal.src = src;
          principal.alt = alt;
          minis.forEach(function (m) { m.classList.remove('bf-activa'); });
          mini.classList.add('bf-activa');
        });
      });
    });
  }

  function initVariantesProducto() {
    document.querySelectorAll('[data-bf-producto]').forEach(function (root) {
      var dataEl = root.querySelector('[data-bf-variantes]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var inventarioEl = root.querySelector('[data-bf-inventario]');
      var inventarioPorId = {};
      if (inventarioEl) {
        try {
          JSON.parse(inventarioEl.textContent).forEach(function (v) { inventarioPorId[v.id] = v; });
        } catch (e) {}
      }

      var idInput = root.querySelector('[data-bf-variant-id]');
      var precioEl = root.querySelector('[data-bf-precio]');
      var tachadoEl = root.querySelector('[data-bf-precio-tachado]');
      var ahorroEl = root.querySelector('[data-bf-ahorro]');
      var botonComprar = root.querySelector('[data-bf-add]');
      var stockEl = root.querySelector('[data-bf-stock]');
      var casiAgotadoEl = root.querySelector('[data-bf-casi-agotado]');
      var grupos = root.querySelectorAll('[data-bf-opcion]');

      function moneyFmt(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      }

      function seleccionActual() {
        var sel = [];
        grupos.forEach(function (g) {
          var activo = g.querySelector('.bf-activa');
          sel.push(activo ? activo.getAttribute('data-bf-valor') : null);
        });
        return sel;
      }

      function encontrarVariante() {
        var sel = seleccionActual();
        return variantes.find(function (v) {
          return v.options.every(function (opt, i) { return sel[i] === null || opt === sel[i]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (idInput) idInput.value = variante.id;
        if (precioEl) precioEl.textContent = moneyFmt(variante.price);
        if (tachadoEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            tachadoEl.textContent = moneyFmt(variante.compare_at_price);
            tachadoEl.hidden = false;
            if (ahorroEl) {
              var pct = Math.round(100 - (variante.price / variante.compare_at_price) * 100);
              ahorroEl.textContent = '-' + pct + '%';
              ahorroEl.hidden = pct <= 0;
            }
          } else {
            tachadoEl.hidden = true;
            if (ahorroEl) ahorroEl.hidden = true;
          }
        }
        if (botonComprar) botonComprar.disabled = !variante.available;
        if (stockEl) {
          stockEl.classList.toggle('bf-producto__stock--ok', variante.available);
          stockEl.classList.toggle('bf-producto__stock--agotado', !variante.available);
          stockEl.querySelector('[data-bf-stock-texto]').textContent = variante.available
            ? stockEl.getAttribute('data-bf-texto-disponible')
            : stockEl.getAttribute('data-bf-texto-agotado');
        }
        if (casiAgotadoEl) {
          var umbral = parseInt(casiAgotadoEl.getAttribute('data-bf-umbral'), 10) || 0;
          var tallaManual = casiAgotadoEl.getAttribute('data-bf-talla-casi-agotado') || '';
          var inv = inventarioPorId[variante.id];
          var pocoStock = inv
            && inv.inventory_management === 'shopify'
            && inv.inventory_policy !== 'continue'
            && typeof inv.inventory_quantity === 'number'
            && inv.inventory_quantity > 0
            && inv.inventory_quantity <= umbral;
          var tallaMarcada = tallaManual !== '' && variante.options.indexOf(tallaManual) !== -1;
          casiAgotadoEl.hidden = !(pocoStock || tallaMarcada);
        }
        var imgSrc = variante.featured_image && (variante.featured_image.src || variante.featured_image);
        if (imgSrc && galeriaPrincipal(root)) {
          galeriaPrincipal(root).src = imgSrc.indexOf('http') === 0 ? imgSrc : ('https:' + imgSrc);
        }
      }

      function galeriaPrincipal(root) {
        return root.querySelector('[data-bf-principal]');
      }

      grupos.forEach(function (grupo) {
        grupo.querySelectorAll('[data-bf-valor]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            grupo.querySelectorAll('[data-bf-valor]').forEach(function (b) { b.classList.remove('bf-activa'); });
            btn.classList.add('bf-activa');
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initDescripcionSegura() {
    document.querySelectorAll('.bf-producto__descripcion img').forEach(function (img) {
      img.addEventListener('error', function () { img.remove(); }, { once: true });
    });
  }

  function initVolver() {
    var link = document.querySelector('[data-bf-volver]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      var vieneDeLaTienda = document.referrer && document.referrer.indexOf(window.location.host) !== -1;
      if (window.history.length > 1 && vieneDeLaTienda) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  function initAgregarCarrito() {
    var forms = document.querySelectorAll('[data-bf-form-comprar]');
    if (!forms.length) return;

    function actualizarIconoCarrito() {
      var iconoActual = document.getElementById('cart-icon-bubble');
      if (!iconoActual) return;
      var contenedor = iconoActual.closest('[id^="shopify-section-"]');
      if (!contenedor) return;
      var seccionId = contenedor.id.replace('shopify-section-', '');
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(seccionId))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var html = data[seccionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevoIcono = doc.getElementById('cart-icon-bubble');
          if (nuevoIcono) iconoActual.outerHTML = nuevoIcono.outerHTML;
        })
        .catch(function () {});
    }

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('[data-bf-add]');
        if (!boton || boton.disabled) return;
        var textoOriginal = boton.textContent;
        boton.disabled = true;
        boton.textContent = 'Añadiendo...';
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              boton.textContent = data.description || 'No se pudo añadir';
              setTimeout(function () { boton.textContent = textoOriginal; boton.disabled = false; }, 2500);
              return;
            }
            boton.textContent = '✓ Añadido al carrito';
            actualizarIconoCarrito();
            setTimeout(function () { boton.textContent = textoOriginal; boton.disabled = false; }, 1800);
          })
          .catch(function () {
            boton.textContent = 'Error, inténtalo de nuevo';
            setTimeout(function () { boton.textContent = textoOriginal; boton.disabled = false; }, 2500);
          });
      });
    });
  }

  function initVerTodo() {
    document.querySelectorAll('[data-bf-ver-todo]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var contenedor = boton.closest('.bf-container');
        if (!contenedor) return;
        contenedor.querySelectorAll('.bf-tarjeta--extra').forEach(function (tarjeta) {
          tarjeta.hidden = false;
          tarjeta.classList.remove('bf-tarjeta--extra');
        });
        var envoltorio = boton.closest('.bf-destacados__ver-todo');
        if (envoltorio) envoltorio.hidden = true;
      });
    });
  }

  function initStockContador() {
    document.querySelectorAll('[data-bf-stock-contador]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-bf-stock-min'), 10) || 1;
      var max = parseInt(el.getAttribute('data-bf-stock-max'), 10) || min;
      if (max <= min) return;
      var niveles = max - min + 1;
      var duracionNivel = 60 / niveles;

      function calcularValor() {
        var minutos = new Date().getMinutes();
        var nivel = Math.floor(minutos / duracionNivel);
        if (nivel >= niveles) nivel = niveles - 1;
        return max - nivel;
      }

      function actualizar() {
        el.textContent = calcularValor();
      }

      actualizar();
      setInterval(actualizar, 15000);
    });
  }

  function initReservaCarrito() {
    var el = document.querySelector('[data-bf-reserva-contador]');
    if (!el) return;
    var duracion = 10 * 60 * 1000;
    var clave = 'bf_reserva_carrito_fin';
    var claveDuracion = 'bf_reserva_carrito_duracion';
    var fin;
    try {
      fin = parseInt(sessionStorage.getItem(clave), 10);
      var duracionGuardada = parseInt(sessionStorage.getItem(claveDuracion), 10);
      if (!fin || fin < Date.now() || duracionGuardada !== duracion) {
        fin = Date.now() + duracion;
        sessionStorage.setItem(clave, fin);
        sessionStorage.setItem(claveDuracion, duracion);
      }
    } catch (e) {
      fin = Date.now() + duracion;
    }

    function actualizar() {
      var restante = fin - Date.now();
      if (restante <= 0) {
        fin = Date.now() + duracion;
        try { sessionStorage.setItem(clave, fin); } catch (e) {}
        restante = duracion;
      }
      var minutos = Math.floor(restante / 60000);
      var segundos = Math.floor((restante % 60000) / 1000);
      el.textContent = minutos + ':' + (segundos < 10 ? '0' : '') + segundos;
    }
    actualizar();
    setInterval(actualizar, 1000);
  }

  function init() {
    initReveals();
    initCarruseles();
    initCifras();
    initGaleriaProducto();
    initVariantesProducto();
    initDescripcionSegura();
    initVolver();
    initAgregarCarrito();
    initVerTodo();
    initStockContador();
    initReservaCarrito();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
